import InterfaceRujukan from "../apiInterface/InterfaceRujukan";
import { join, values, mapValues } from "lodash";
import ErrorAlert from "@/utility/ErrorAlert";

class DataRujukan {
  async getDataRujukanReg(reg) {
    let dt: any;
    await InterfaceRujukan.getRujukanByReg(reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, " Surat Rujukan")
        // if (dt["status"] == 422) {
        //   dt = e.response.data.errors;
        // } else {
        //   dt = {
        //     data: dt,
        //     status: dt["status"],
        //     err: "ERR " + e.response.status + " : " + e.response.data.message
        //   };
        //   // dt = e.response
        // }
        // console.log("kosong", dt);
      });
    return dt;
  }
  async getDataRujukanId(id) {
    let dt: any;
    await InterfaceRujukan.getRujukanById(id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Surat Rujukan")
        // if (dt["status"] == 422) {
        //   dt = e.response.data.errors;
        // } else {
        //   dt = {
        //     data: dt,
        //     status: dt["status"],
        //     err: "ERR " + e.response.status + " : " + e.response.data.message
        //   };
        //   // dt = e.response
        // }
      });
    return dt;
  }

  async saveDataRujukan(
    tujuan_id,
    unit_tujuan_text,
    dokter_id,
    unit_id,
    register_id,
    pasien_rm,
    diagnosis,
    alasan,
    kondisi,
    terapi_diberikan,
    penunjang,
    terapi_diharapkan
  ) {
    let dt: object = {};
    await InterfaceRujukan.saveRujukan(
      tujuan_id,
      unit_tujuan_text,
      dokter_id,
      unit_id,
      register_id,
      pasien_rm,
      diagnosis,
      alasan,
      kondisi,
      terapi_diberikan,
      penunjang,
      terapi_diharapkan
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log("respon", e.response);
        dt = e.response;
        ErrorAlert.showErrorAlert(e)
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = {
        //     data: dt,
        //     status: dt["status"],
        //     err: "ERR " + e.response.status + " : " + e.response.data.message
        //   };
        //   // dt = e.response
        // }
      });
    return dt;
  }
  async editDataRujukan(
    id,
    tujuan_id,
    unit_tujuan_text,
    dokter_id,
    unit_id,
    register_id,
    pasien_rm,
    diagnosis,
    alasan,
    kondisi,
    terapi_diberikan,
    penunjang,
    terapi_diharapkan
  ) {
    let dt: object = {};
    await InterfaceRujukan.editRujukan(
      id,
      tujuan_id,
      unit_tujuan_text,
      dokter_id,
      unit_id,
      register_id,
      pasien_rm,
      diagnosis,
      alasan,
      kondisi,
      terapi_diberikan,
      penunjang,
      terapi_diharapkan
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log("respon", e.response);
        dt = e.response;
        ErrorAlert.showErrorAlert(e)
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = {
        //     data: dt,
        //     status: dt["status"],
        //     err: "ERR " + e.response.status + " : " + e.response.data.message
        //   };
        //   // dt = e.response
        // }
      });
    return dt;
  }

  async saveDataTtdRujukan(idRujukan, user_id, password) {
    let dt: object = {};
    await InterfaceRujukan.saveTtdRujukan(idRujukan, user_id, password)
      .then(response => {
        dt = response;
      })
      .catch(e => {
        // console.log("respon", e.response);
        dt = e.response;
        // ErrorAlert.showErrorAlert(e)
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = {
        //     data: dt,
        //     status: dt["status"],
        //     err: "ERR " + e.response.status + " : " + e.response.data.message
        //   };
        //   // dt = e.response
        // }
      });
    return dt;
  }


  async getDataJawabanRujukanReg(reg) {
    let dt: any;
    await InterfaceRujukan.getJawabanRujukanByReg(reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, " Surat Jawaban Rujukan")
      });
    return dt;
  }

  async getDataJawabanRujukanId(id) {
    let dt: any;
    await InterfaceRujukan.getJawabanRujukanById(id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Surat Jawaban Rujukan")
      });
    return dt;
  }


  async saveDataJawabanRujukan(
    tgl_surat,
    register_id,
    pasien_rm,
    dokter_id,
    dokter_tujuan,
    faskes_tujuan_id,
    faskes_tujuan_nama,
    diagnosis,
    terapi,
    saran
  ) {
    let dt: object = {};
    await InterfaceRujukan.saveJawabanRujukan(
      tgl_surat,
      register_id,
      pasien_rm,
      dokter_id,
      dokter_tujuan,
      faskes_tujuan_id,
      faskes_tujuan_nama,
      diagnosis,
      terapi,
      saran
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e)
      });
    return dt;
  }

  async editDataJawabanRujukan(
    id,
    tgl_surat,
    register_id,
    pasien_rm,
    dokter_id,
    dokter_tujuan_nama,
    faskes_tujuan_id,
    nama_faskes_tujuan,
    diagnosis,
    terapi,
    saran
  ) {
    let dt: object = {};
    await InterfaceRujukan.editJawabanRujukan(
      id,
      tgl_surat,
      register_id,
      pasien_rm,
      dokter_id,
      dokter_tujuan_nama,
      faskes_tujuan_id,
      nama_faskes_tujuan,
      diagnosis,
      terapi,
      saran
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e)
      });
    return dt;
  }

  async saveDataTtdJawabanRujukan(reg, user_id, password) {
    let dt: object = {};
    await InterfaceRujukan.saveTtdJawabanRujukan(reg, user_id, password)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        // ErrorAlert.showErrorAlert(e)
      });
    return dt;
  }

  async getDataFaskesCustom(term) {
    let dt = []
    await InterfaceRujukan.getFaskesCustom(term).then((response) => {
      dt = response.data
    })
      .catch((e) => {
        // console.log(e);
      });
    return dt
  }
}

export default new DataRujukan();
